import { FieldError, FieldStatus } from '@/framework/base/components/FieldInfo';
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        value: {
            type: String,
            required: true
        },
        contextId: {
            type: Number,
            required: true
        },
        readOnly: {
            type: Boolean
        }
    },
    created(): void {
        this.initValue = this.value;
        this.status.objId = this.contextId;
    },
    data() {
        const file: File | null = null;

        return {
            file,
            status: new FieldStatus(false, false, 0),
            initValue: '',
            imageSource: ''
        };
    },
    computed: {
        image: {
            get(): string {
                if (this.imageSource) {
                    return this.imageSource;
                }
                if (this.value != null && this.value != this.imageSource) {
                    return this.value;
                }
                return this.imageSource;
            },
            set(value: string) {
                this.imageSource = value;
                if (this.value != value) {
                    this.$emit('updated', value);
                }
            }
        }
    },

    methods: {
        createImage(event: Event) {
            const input = event.target as HTMLInputElement;
            const file = input?.files?.[0];
            const reader = new FileReader();
            reader.onload = (event) => {
                // @ts-expect-error : generated method
                this.image = event.target.result;
                this.setUpdated(this.image);
            }
            reader.readAsDataURL(file);
        },
        setInitValue(value: string): void {
            this.initValue = value;
            this.status.objId = this.contextId;
        },
        save(): void {
            this.initValue = this.value;
            this.status.clear(this.contextId);
            this.$emit('status', this.status);
        },
        setUpdated(value: string): void {
            this.status.updated = value != this.initValue;
            this.$emit('update:value', value);
            this.$emit('status', this.status);
        },
        setError(value: FieldError): void {
            this.status.error = value.error;
            this.$emit('status', this.status);
        },
        touch(): void {
            // To implement
        },
        setFocus(): void {
            // To implement
        },
        missing(): void {
           // To implement
        },
    },
})
